import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';

import Loading from 'uI/Loading/Loading';

import { checkPassword } from 'store/myAccount-actions';

import classes from './ConfirmPassword.module.css';

const ConfirmPassword = props => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [enableAddBtn, setEnableAddBtn] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [password]);

  useEffect(() => {
    setLoading(false);
  }, [props.success]);

  const closeHandler = () => {
    props.close();
    setPassword('');
  };

  const changeInputHandler = event => {
    setPassword(event.target.value);
    setEnableAddBtn(password.length >= 8);
  };

  const saveHandler = () => {
    setLoading(true);
    (async () => {
      let checkPasswordData = await checkPassword(password);
      if (checkPasswordData) {
        props.save();
      } else {
        setLoading(false);
        setError(true);
        setEnableAddBtn(false);
      }
    })();
  };

  return (
    <Dialog
      onClose={closeHandler}
      open={props.open}
      fullWidth
      maxWidth="xs"
      className={classes.newEmailcontainer}
    >
      {!props.success ? (
        <>
          <p className={classes.title}>
            Confirma tu contraseña para actualizar tus datos.
          </p>
          <TextField
            label="Contraseña actual"
            className={classes.textField}
            placeholder="Contraseña actual"
            value={password}
            variant="outlined"
            onChange={changeInputHandler}
            size="small"
          />
          {error && (
            <p className={classes.errorText}>
              Tu contraseña es incorrecta
            </p>
          )}
        </>
      ) : (
        <p className={classes.title}>
          Los cambios a tu perfil se realizaron con éxito
        </p>
      )}
      <div className={classes.btnsContainer}>
        {!loading ? (
          <Button
            className={classes.addEmailBtn}
            onClick={props.success ? closeHandler : saveHandler}
            disabled={!enableAddBtn}
          >
            {props.success ? 'De acuerdo' : 'Confirmar'}
          </Button>
        ) : (
          <Loading />
        )}
      </div>
    </Dialog>
  );
};

ConfirmPassword.propTypes = {
  // eslint-disable-next-line react/require-default-props
  close: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  save: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  success: PropTypes.func
};

export default ConfirmPassword;
